import React from 'react';
import { motion } from 'framer-motion';
import { Brain, HeartPulse, BedDouble } from 'lucide-react';
const symptoms = [{
  number: '01',
  icon: Brain,
  title: 'Cortisol-Anstieg',
  text: 'Jedes nächtliche Aufwachen aktiviert Ihre Stressachse. Der Cortisolspiegel steigt — und verhindert, dass Sie in die regenerativen Tiefschlafphasen zurückfinden.'
}, {
  number: '02',
  icon: HeartPulse,
  title: 'Kardiovaskuläre Belastung',
  text: 'Studien zeigen: Männer mit Nykturie (≥2x pro Nacht) haben ein signifikant erhöhtes Risiko für Bluthochdruck und Herz-Kreislauf-Erkrankungen.'
}, {
  number: '03',
  icon: BedDouble,
  title: 'Zerstörte Schlafarchitektur',
  text: 'Ihr Körper braucht 90-Minuten-Zyklen ohne Unterbrechung. Nykturie fragmentiert diese Zyklen und raubt Ihnen die Phasen, in denen echte Zellregeneration stattfindet.'
}];
export function ProblemSection() {
  return <section className="py-28 md:py-32 bg-slate-50 text-slate-900 relative overflow-hidden" data-id="element-291">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-292">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start" data-id="element-293">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:sticky lg:top-32" data-id="element-294">
            <span className="text-brand-500 font-bold tracking-[0.2em] text-sm uppercase mb-4 block" data-id="element-295">
              DAS PROBLEM
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-slate-900 mb-8 leading-tight" data-id="element-296">
              Warum Nykturie kein Schicksal ist
            </h2>
            <p className="text-lg md:text-xl text-slate-600 leading-relaxed mb-10 font-light" data-id="element-297">
              Wenn Sie nachts zwei- oder dreimal aufstehen müssen, ist das mehr
              als nur lästig — es ist ein ernstzunehmender Stressfaktor für
              Ihren gesamten Organismus. Jede Unterbrechung Ihres Schlafs löst
              eine Kaskade aus, die Ihre Gesundheit langfristig belastet.
            </p>
            <div className="p-8 bg-white border-l-4 border-brand-500 rounded-r-xl shadow-sm" data-id="element-298">
              <p className="text-slate-700 font-medium italic text-lg leading-relaxed" data-id="element-299">
                "Die gute Nachricht: Mit der richtigen Unterstützung kann Ihr
                Körper diesen Kreislauf durchbrechen."
              </p>
            </div>
          </motion.div>

          <div className="space-y-8" data-id="element-300">
            {symptoms.map((symptom, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="group bg-white p-8 md:p-10 rounded-xl border border-slate-200 hover:border-brand-200 transition-all duration-300 hover:shadow-md" data-id="element-301">
                <div className="flex items-start gap-6" data-id="element-302">
                  <span className="text-5xl font-serif font-bold text-brand-100 leading-none shrink-0" data-id="element-303">
                    {symptom.number}
                  </span>
                  <div className="flex-1 min-w-0" data-id="element-304">
                    <div className="flex items-center gap-3 mb-4 min-w-0" data-id="element-305">
                      <div className="p-2 rounded-lg bg-slate-50 group-hover:bg-brand-50 transition-colors shrink-0" data-id="element-306">
                        <symptom.icon className="w-6 h-6 text-brand-500" data-id="element-307" />
                      </div>
                      <h3 className="text-2xl font-bold text-slate-900 relative break-words min-w-0 pr-3" data-id="element-308">
                        {symptom.title}
                        <span className="absolute top-0 -right-0 w-2 h-2 rounded-full bg-red-500 animate-pulse shadow-[0_0_8px_rgba(239,68,68,0.6)]" data-id="element-309" />
                      </h3>
                    </div>
                    <p className="text-slate-600 text-base leading-loose group-hover:text-slate-700 transition-colors" data-id="element-310">
                      {symptom.text}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}